import React, { useCallback } from 'react';
import PropTypes from 'prop-types';

import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';

const AssignmentResultQuestionHeadCell = (props) => {
  const { question, href, onOpenPopover, onClosePopover } = props;

  const handleOpenPopover = useCallback(
    (event) => {
      onOpenPopover(event, question);
    },
    [onOpenPopover, question]
  );

  return (
    <Link href={href}>
      <Typography
        aria-haspopup="true"
        varian="subtitle2"
        onMouseEnter={handleOpenPopover}
        onMouseLeave={onClosePopover}
      >
        {question.name}
      </Typography>
    </Link>
  );
};

AssignmentResultQuestionHeadCell.propTypes = {
  question: PropTypes.object,
  href: PropTypes.string,

  onOpenPopover: PropTypes.func,
  onClosePopover: PropTypes.func,
};

AssignmentResultQuestionHeadCell.defaultProps = {
  href: '/',
  question: {},
  onOpenPopover() {},
  onClosePopover() {},
};

export default AssignmentResultQuestionHeadCell;
